
import React from 'react';
import { GENERAL } from '../../assets/images/images';
import Helper from '../../core/helper/helper';

const AppleStoreButton = () => {
  if (Helper.hideAppleStore && Helper.hideAppleStore()) {
    return <React.Fragment />;
  }
  return (
    <a className="applestore-button-container" role={'button'}
      href={Helper.applestoreLink} target='_blank' rel="noopener noreferrer">
      <img src={GENERAL.applestore} alt="applestore-button" />
    </a>
  );
}
export default AppleStoreButton;